import { AsyncAutocompleteFieldType, HookAutocompleteField } from 'components/shared/dropdowns'
import { useCompanyTypeAheadQuery } from 'graphql/bindings/AdminBindings'
import React from 'react'

export const CompanyField: React.FC<AsyncAutocompleteFieldType> = props => {
  return (
    <HookAutocompleteField
      useQuery={useCompanyTypeAheadQuery}
      transform={data =>
        data.companyTypeahead.map(elem => ({
          label: elem.name + (elem.domain && ` <${elem.domain}>`),
          value: elem.id,
        }))
      }
      {...props}
    />
  )
}
